module.exports = __webpack_public_path__ + "img/home_fr15.c4204ecf.png";